import {
  CompanyFactKey,
  CompanyFactSchemaVersion,
  ConflictStrategy,
  type FactKeyConfig,
} from '../core'

export const CUSTOMER_RULES_KEY_CONFIG: Partial<
  Record<CompanyFactKey, FactKeyConfig>
> = {
  [CompanyFactKey.CUSTOMER_RULES_BUSINESS_SUPPORT]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Business Support Rules',
    conflictStrategy: ConflictStrategy.APPEND,
  },
  [CompanyFactKey.CUSTOMER_RULES_WORKER_SUPPORT]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Worker Support Rules',
    conflictStrategy: ConflictStrategy.APPEND,
  },
}
